import { useEffect } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import ProdComponentTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import componentIcon from "../../../../../assets/new-product-detail-cats/sub-icons/product-component-icon.svg";
// Removed subcategory support - keeping imports commented for potential future use
// import ProdSubBox from "../../components/SubcategoryBox/";
// import { componentSubcategoryService } from "../../../../../apis/Product/ProductComponentSubcategoryApi";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProdComponentContents = ({
  productId,
  systemBoundaryProps,
}) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;
  // Removed subcategory support - keeping state commented for potential future use
  // const [subcategory, setSubcategory] = useState([]);

  // Removed subcategory fetching - keeping commented for potential future use
  // useEffect(() => {
  //   const fetchSubcategories = async () => {
  //     try {
  //       const fetchedSubcategories =
  //         await componentSubcategoryService.getComponentSubs(productId);
  //       setSubcategory(fetchedSubcategories);
  //     } catch (error) {
  //       console.error("Failed to fetch subcategories", error);
  //     }
  //   };

  //   if (productId) {
  //     fetchSubcategories();
  //   }
  // }, [productId]);

  // Removed subcategory functions - keeping commented for potential future use
  // const addSubcategory = async (text, setText) => {
  //   if (text.trim()) {
  //     try {
  //       const createdSubcategory =
  //         await componentSubcategoryService.createComponentSub(productId, {
  //           subcategory: text,
  //         });

  //       setSubcategory([
  //         ...subcategory,
  //         {
  //           id: createdSubcategory.id,
  //           subcategory: text,
  //         },
  //       ]);
  //       setText("");
  //     } catch (error) {
  //       console.error("Failed to create subcategory", error);
  //     }
  //   }
  // };

  // const updateSubcategory = async (id, text) => {
  //   try {
  //     await componentSubcategoryService.updateComponentSub(productId, id, {
  //       subcategory: text,
  //     });

  //     setSubcategory(
  //       subcategory.map((sub) =>
  //         sub.id === id ? { ...sub, subcategory: text } : sub
  //       )
  //     );
  //   } catch (error) {
  //     console.error("Failed to update assumption", error);
  //   }
  // };

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("PRODUCT_COMPONENTS")}
        subDescription={t("PRODUCT_COMPONENTS_DESC")}
        isNormal={true}
        number={"31.1a"}
        systemBoundaryProps={systemBoundaryProps}
        showSystemBoundary={false}
        icon={componentIcon}
      />

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-component-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProdComponentTable productId={productId} />
        </TableLoadingWrapper>
      )}

      {/* Removed subcategory UI - keeping commented for potential future use */}
      {/* {showCategory && (
        <>
          <div>
            <ProdSubBox
              title={"Create custom category"}
              desc={t(
                "For groups of materials, e.g: metals, plastics, polymers.."
              )}
              productId={productId}
              isInput={true}
              handleCreate={addSubcategory}
            />
            {shouldShowTable && (
              <TableLoadingWrapper
                tableId={`prod-componentnew-${productId}`}
                minLoadTime={3000}
                maxLoadTime={20000}
              >
                <ProdComponentTable
                  productId={productId}
                  isSubcategory={true}
                />
              </TableLoadingWrapper>
            )}
          </div>
          <div>
            {subcategory &&
              subcategory?.length > 0 &&
              subcategory.map((sub) => {
                return (
                  <div>
                    <ProdSubBox
                      title={sub.subcategory}
                      desc={t(
                        "For groups of materials, e.g: metals, plastics, polymers.."
                      )}
                      productId={productId}
                      isInput={true}
                      handleCreate={addSubcategory}
                      itemId={sub.id}
                      handleUpdate={updateSubcategory}
                    />
                    {shouldShowTable && (
                      <TableLoadingWrapper
                        tableId={`prod-componentsub-${productId}`}
                        minLoadTime={3000}
                        maxLoadTime={20000}
                      >
                        <ProdComponentTable
                          productId={productId}
                          subcategoryId={sub.id}
                          isSubcategory={true}
                        />
                      </TableLoadingWrapper>
                    )}
                  </div>
                );
              })}
          </div>
        </>
      )} */}

      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProdComponentContents;
